<ng-template #modalLG let-modal>
  <div class="modal-header" style="background-color: transparent; border-bottom: none;">
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="d-flex flex-column justify-content-center text-center" style="padding: 30px 0 64px 0">
    <p class="title-modal">Convertir le document</p>
    <p class="text-modal">
      Veuillez choisir le type de document à générer.
    </p>

    <div class="form-group">
      <!-- Labels conditionnels -->
      <label *ngIf="isDevisPage">
        Convertir Devis en <span class="text-danger red-tx" aria-hidden="true">*</span>
      </label>
      <label *ngIf="isCommandeClientPage">
        Convertir commande client en <span class="text-danger red-tx" aria-hidden="true">*</span>
      </label>
      <label *ngIf="isBonLivraisonPage">
        Convertir bon de livraison en <span class="text-danger red-tx" aria-hidden="true">*</span>
      </label>
      <label *ngIf="isFacturePage">
        Convertir facture en <span class="text-danger red-tx" aria-hidden="true">*</span>
      </label>
      <label *ngIf="isCommandeFournisseurPage">
        Convertir commande fournisseur en <span class="text-danger red-tx" aria-hidden="true">*</span>
      </label>
      <label *ngIf="isBonReceptionPage">
        Convertir bon de réception en <span class="text-danger red-tx" aria-hidden="true">*</span>
      </label>
      <label *ngIf="isFactureFournisseurPage">
        Convertir facture fournisseur en <span class="text-danger red-tx" aria-hidden="true">*</span>
      </label>

      <div class="checkbox-group">
        <!-- Options pour Devis -->
        <label class="container" [class.option-disabled]="isOptionDisabled('Commande')" *ngIf="isDevisPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Commande" 
            aria-label="Commande"
            [disabled]="isOptionDisabled('Commande')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Commande</span>
        </label>
        <label class="container" [class.option-disabled]="isOptionDisabled('Bon de livraison')" *ngIf="isDevisPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Bon de livraison" 
            aria-label="Bon de livraison"
            [disabled]="isOptionDisabled('Bon de livraison')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Bon de livraison</span>
        </label>
        <label class="container" [class.option-disabled]="isOptionDisabled('Facture')" *ngIf="isDevisPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Facture" 
            aria-label="Facture"
            [disabled]="isOptionDisabled('Facture')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Facture</span>
        </label>

        <!-- Options pour Commande Client -->
        <label class="container" [class.option-disabled]="isOptionDisabled('Bon de livraison')" *ngIf="isCommandeClientPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Bon de livraison" 
            aria-label="Bon de livraison"
            [disabled]="isOptionDisabled('Bon de livraison')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Bon de livraison</span>
        </label>
        <label class="container" [class.option-disabled]="isOptionDisabled('Facture')" *ngIf="isCommandeClientPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Facture" 
            aria-label="Facture"
            [disabled]="isOptionDisabled('Facture')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Facture</span>
        </label>

        <!-- Options pour Bon de Livraison -->
        <label class="container" [class.option-disabled]="isOptionDisabled('Facture')" *ngIf="isBonLivraisonPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Facture" 
            aria-label="Facture"
            [disabled]="isOptionDisabled('Facture')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Facture</span>
        </label>

        <!-- Options pour Facture -->
        <label class="container" [class.option-disabled]="isOptionDisabled('Avoir')" *ngIf="isFacturePage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Avoir" 
            aria-label="Avoir"
            [disabled]="isOptionDisabled('Avoir')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Avoir</span>
        </label>

        <!-- Options pour Commande Fournisseur -->
        <label class="container" [class.option-disabled]="isOptionDisabled('Bon de réception')" *ngIf="isCommandeFournisseurPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Bon de réception" 
            aria-label="Bon de réception"
            [disabled]="isOptionDisabled('Bon de réception')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Bon de réception</span>
        </label>
        <label class="container" [class.option-disabled]="isOptionDisabled('Facture fournisseur')" *ngIf="isCommandeFournisseurPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Facture fournisseur" 
            aria-label="Facture fournisseur"
            [disabled]="isOptionDisabled('Facture fournisseur')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Facture fournisseur</span>
        </label>

        <!-- Options pour Bon de Réception -->
        <label class="container" [class.option-disabled]="isOptionDisabled('Facture fournisseur')" *ngIf="isBonReceptionPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Facture fournisseur" 
            aria-label="Facture fournisseur"
            [disabled]="isOptionDisabled('Facture fournisseur')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Facture fournisseur</span>
        </label>

        <!-- Options pour Facture Fournisseur -->
        <label class="container" [class.option-disabled]="isOptionDisabled('Avoir')" *ngIf="isFactureFournisseurPage">
          <input 
            type="radio" 
            class="form-check-input"
            name="documentType"
            [(ngModel)]="selectedDocumentType" 
            value="Avoir" 
            aria-label="Avoir"
            [disabled]="isOptionDisabled('Avoir')"
            (change)="onDocumentTypeChange()"
          >
          <span class="checkmark"></span>
          <span>Avoir</span>
        </label>

        <!-- Message si aucune option disponible -->
        <div *ngIf="!hasAvailableOptions" class="alert alert-info mt-2">
          Aucune option de conversion disponible pour cette page.
        </div>
      </div>
    </div>

    <img *ngIf="selectedDocumentType" [src]="getImageSrc()" [alt]="selectedDocumentType + ' Preview'" class="mt-1">
    
    <div class="modal-footer p-0" style="justify-content: center; gap: 16px; border-top: none;">
      <button
        type="button"
        class="btn btn-primary d-flex align-items-center justify-content-center"
        style="padding: 8px 16px; font-size: 14px;"
        (click)="convertDocument()"
        [disabled]="!selectedDocumentType || !hasAvailableOptions || isOptionDisabled(selectedDocumentType) || isConverting"
      >
        Convertir
      </button>
      <button
        type="button"
        class="btn d-flex align-items-center justify-content-center"
        style="padding: 8px 16px; font-size: 14px;background-color: rgba(128, 131, 144, 0.16);"
        (click)="modal.dismiss('Cancel click')"
      >
        Annuler
      </button>
    </div>
  </div>
</ng-template>
